module.exports = __webpack_public_path__ + "img/export.0154ec2b.svg";